module.exports = __webpack_public_path__ + "img/06black.e9b0f482.gif";